<template>
    <my-dialog :title="title" :visible.sync="showDetailVisible" @close="closeDialog()" :close-on-click-modal="false"
        :modal="false" width="80%">
        <div class="main_bg">
            <div class="item_info border_Green">
                <div class="item_title">
                    <div class="title">库存商品信息</div>
                    <div class="btnDiv">
                    </div>
                </div>
                <el-table :data="productTableData" style="width: 100%" border
                    :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                    <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
                    <el-table-column prop="typeName" label="类型" width="140"></el-table-column>
                    <el-table-column prop="productName" label="系列" width="160"> </el-table-column>
                    <el-table-column prop="specification" label="商品名称"></el-table-column>
                    <el-table-column prop="quantity" label="数量" width="70"></el-table-column>
                    <el-table-column prop="realQuantity" label="真实数量" width="140">
                        <template slot-scope="scope">
                            <el-input-number v-model.number="scope.row.realQuantity" placeholder="请输入真实数量" size="small"
                                :min="0" :step="1" style="width: 100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unit" label="单位" width="70"></el-table-column>
                    <el-table-column prop="productDate" label="生产日期" width="110"></el-table-column>
                    <el-table-column prop="expireDate" label="过期日期" width="110"></el-table-column>
                    <el-table-column prop="price" label="售价(元)" width="140"></el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" icon="el-icon-close" @click="closeDialog()">取消</el-button>
            <el-button size="small" v-if="this.$checkBtnPermission('/storeCheck/index', 'realQty')"
                icon="el-icon-s-check" :loading="loading" type="warning" @click="handleSaveRealQtyClick">保存</el-button>
        </div>
    </my-dialog>
</template>

<script>
import {
    GetMonthStoreProductExportList,
    BatchSaveRealQty
} from "@/api/productApi.js";
export default {
    data() {
        return {
            showDetailVisible: false,
            loading: false,
            title: "门店库存盘点记录真实数量",
            storeCheckInfo: {},
            productTableData: [],
        };
    },
    created() { },
    mounted() { },
    components: {
    },
    methods: {
        // 展示详情
        showAuditSubscriptionDetail(info) {
            this.storeCheckInfo = info;
            GetMonthStoreProductExportList({
                storeKeyId: info.storeKeyId,
                month: info.month,
                year: info.year,
            }).then(res => {
                if (res.code == 1) {
                    this.productTableData = [];
                    if (res.data != null && res.data.length > 0) {
                        var index = 1;
                        res.data.forEach((item) => {
                            this.productTableData.push({
                                rowNumber: index++,
                                productKeyId: item.productInfo.keyId,
                                typeName: item.productInfo.typeName,
                                productName: item.productInfo.productName,
                                specification: item.productInfo.specification,
                                quantity: item.quantity,
                                unit: item.productInfo.unit,
                                remark: item.remark,
                                costMoney: item.costMoney,
                                productDate: item.productDate,
                                expireDate: item.expireDate,
                                keyId: item.keyId,
                                price: item.price,
                                realQuantity: item.realQuantity,
                            });
                        });
                    }
                    this.title = `${this.storeCheckInfo.year}年${this.storeCheckInfo.month}月库存商品真实数量`;
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.showDetailVisible = true;
        },
        // 关闭详情弹出框
        closeDialog() {
            this.subscriptionInfo = {};
            this.showDetailVisible = false;
        },
        // 保存真实数量
        handleSaveRealQtyClick() {
            // 校验表单
            if (this.productTableData.length == 0) {
                this.$message.error("请添加商品！");
                return;
            }
            this.loading = true;
            BatchSaveRealQty({
                storeKeyId: this.storeCheckInfo.storeKeyId,
                month: this.storeCheckInfo.month,
                year: this.storeCheckInfo.year,
                dtls: this.productTableData.map(item => ({
                    keyId: item.keyId,
                    qty: item.realQuantity,
                }))
            }).then(res => {
                if (res.code == 1) {
                    this.$message.success("保存成功！");
                    this.closeDialog();
                    this.$parent.getListData();
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.$message.error("保存失败!");
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>
<style scoped>
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.formDiv {
    border: 1px solid #e9e7e7;
    padding: 10px;
    border-radius: 5px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;
}

.item_title .title {
    display: inline-block;
    unicode-bidi: isolate;
}

.item_title .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
}

.descriptions-item-value {
    display: inline-block;
    min-width: 100px;
    text-align: left;
}
</style>